/* *********************************
 *
 *      画面遷移用空ページ
 *
 ********************************* */
/*-------------------
     モジュールのimport
 ---------------------*/
import React from 'react';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import axios from 'axios';

/*-------------------
    定数のimport
 ---------------------*/
import { API_PATH } from '../constant/constant';

/**
 * 画面遷移用空ページ
 */
class EmptyPage extends Component {
  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(props.location.search);
    // アクセストークン生成に必要な「code」をURLから取得
    const code = searchParams.get('code') || '';
    this.state = { code, tikuA: false, tikuB: false, tikuC: false, userId: '' };
  }

  /**
   *一度目の描画終了時に実行される
   *
   * @memberof EmptyPage
   */
  componentDidMount = async () => {
    const { code } = this.state;

    if (code === '') return;

    // URLSearchParamsしないと400エラーになる。
    const data = new URLSearchParams({
      grant_type: 'authorization_code',
      code: code,
      redirect_uri: 'https://t-blams.linksmart.jp/web/qwfgsckq/LineAdd/', // 「LINEログイン設定」で設定したコールバックURL
      client_id: '2006517724', // チャネルID
      client_secret: 'edce18e89eb71aae69cbc22b5730d1af', // チャネルシークレット
    });

    const response = await axios
      .post('https://api.line.me/oauth2/v2.1/token', data.toString(), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
      .catch((err) => {
        console.log(err.response.data);
        return false;
      });

    console.log('GET Seccess:', response);
    if (response === false) return;

    const { data: responseData = '' } = response;
    const { access_token: accessToken = '' } = responseData;

    const resData = await axios
      .get('https://api.line.me/oauth2/v2.1/userinfo', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .catch((err) => {
        console.log(err.response.data);
        return false;
      });

    if (resData === false) return;

    const { data: resData2 = '' } = resData;
    const { sub: userId = '' } = resData2;

    this.setState({
      userId,
    });
  };

  test = async () => {
    const { tikuA, tikuB, tikuC, userId } = this.state;

    const array = [];
    if (tikuA === true) array.push('A');
    if (tikuB === true) array.push('B');
    if (tikuC === true) array.push('C');

    if (array.length === 0) {
      window.alert('地区を一つは選択して下さい。');
      return;
    }

    // DBに地区情報を設定する。
    axios
      .post(`${API_PATH}/v/test/c/lnadd`, { array, userId })
      .then(() => {
        window.alert('登録しました。');
      })
      .catch(() => {
        window.alert('登録に失敗しました。');
      });
  };

  /**
   *画面遷移用空ページ
   *
   * @memberof DraftConfirmation
   */
  render() {
    const { tikuA, tikuB, tikuC } = this.state;
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div style={{ marginBottom: '20px' }}>登録する地区を撰んで下さい。</div>
        <div>
          <label htmlFor="id01">
            <input
              type="checkbox"
              id="id01"
              onChange={() => {
                this.setState({ tikuA: !tikuA });
              }}
            />
            &nbsp; 地区A
          </label>
        </div>
        <div>
          <label htmlFor="id02">
            <input
              type="checkbox"
              id="id02"
              onChange={() => {
                this.setState({ tikuB: !tikuB });
              }}
            />
            &nbsp; 地区B
          </label>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="id03">
            <input
              type="checkbox"
              id="id03"
              onChange={() => {
                this.setState({ tikuC: !tikuC });
              }}
            />
            &nbsp; 地区C
          </label>
        </div>
        &emsp;
        <button onClick={() => this.test()}>登録</button>
      </div>
    );
  }
}

EmptyPage.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    path: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};
export default withRouter(EmptyPage);
